import React, { useContext } from "react";
import { useState, useEffect } from "react";
import Select from "react-select";
import { Table, Button, Form, Pagination } from "react-bootstrap";
import { Context } from "../../../../utils/context";
import { getDownloadDataExcel, postData } from "../../../../utils/api";
import { Link, useLocation } from "react-router-dom";
import {
  formatDateToIST,
  IDS,
  OrderStatusIds,
  ReturnStatusIds,
  RoleId,
  ServiceIds,
} from "../../../../utils/common";
import ProductModal from "../ProductModal";
import ProductVariantModal from "../ProductVariantModal";
import Pagination_Holder from "../../../common/Pagination_Holder/Pagination_Holder";

import DatePicker from "react-datepicker";
import search1 from "../../../assets/icons/search.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import ModalSave from "../../../common/ModelSave";
function PendingOrdersTable({
  user,
  OrderByOptions,
  resultsPerPageOptions,
  storeCategories,
  vendorServices,
  GetAllCounts,
  // orderStatus,
}) {
  const {
    getData,
    editStatusData,
    deleteData,
    ErrorNotify,
    isAllow,
    Per_Page_Dropdown,
    Select2Data,
    usertype,
    IMG_URL,
  } = useContext(Context);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset: resetForm,
    setValue,
    resetField,
    watch,
    trigger,
  } = useForm();

  const [perPage, setperPage] = useState({
    value: 25,
    label: "Results per page: 25",
  });

  const [sortOrder, setSortOrder] = useState({
    value: "DESC",
    label: "Sort-by date (Descending)",
  });

  const [data, setData] = useState([]);
  const [totalPages, settotalPages] = useState();
  const [onPageChange, setonPageChange] = useState(1);
  const [search, setSearch] = useState("");
  const [searchCustomer, setSearchCustomer] = useState("");
  const [searchProduct, setSearchProduct] = useState("");

  const [searchCustomerContact, setSearchCustomerContact] = useState("");
  const [reset, setReset] = useState();
  const [searchOrderStatus, setSearchOrderSatatus] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [option, setOption] = useState();
  const [hideFilter, setHideFilter] = useState(false);
  const [storeCategory, setStoreCategory] = useState("");
  const [productCategory, setProductCategory] = useState("");
  const [selectedStatus, setSelectedStatus] = useState({});
  const [orderStatuses, setOrderStatuses] = useState({});
  const [statusErrors, setStatusErrors] = useState({});
  const [selectedOrderStatus, setSelectedOrderStatus] = useState(null);
  const [allOrderStatuses, setAllOrderStatuses] = useState([]);
  // Dashboard cards open this page as /orders/all-orders?status=<order status id>
  const urlStatusId = new URLSearchParams(useLocation().search).get("status");
  const [allProducts, setAllProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [appliedProduct, setAppliedProduct] = useState(null);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const getOrderStatuses = async (product_order_id) => {
    const response = await getData(
      `/common/masters/all-order-status/${product_order_id}`,
    );

    if (response?.success) {
      const formatted = await Select2Data(response?.data, "order_status_id");

      setOrderStatuses((prev) => ({
        ...prev,
        [product_order_id]: formatted,
      }));
    }
  };

  const getAllOrderStatuses = async () => {
    const response = await getData(`/common/masters/all-order-status/0`);

    if (response?.success) {
      const formatted = await Select2Data(response?.data, "order_status_id");
      setAllOrderStatuses(formatted);
    }
  };

  const getAllProduct = async () => {
    const response = await getData(`/common/masters/product`);

    if (response?.success) {
      const formatted = await Select2Data(response?.data, "product_id");
      setAllProducts(formatted);
    }
  };

  useEffect(() => {
    getAllOrderStatuses();
    getAllProduct();
  }, []);

  // Apply the order status coming from the dashboard card in the Order Status filter
  useEffect(() => {
    if (!urlStatusId || allOrderStatuses.length === 0) return;
    const option = allOrderStatuses.find(
      (status) => String(status.value) === String(urlStatusId),
    );
    if (option) {
      setSelectedOrderStatus(option);
      setonPageChange(1);
      // reload the list with the selected status
      setReset((prev) => !prev);
    }
  }, [urlStatusId, allOrderStatuses]);

  const [searchDateTo, setSearchDateTo] = useState();
  const [searchDateFrom, setSearchDateFrom] = useState();

  const [searchStartTime, setSearchStartTime] = useState();
  const [searchEndTime, setSearchEndTime] = useState();

  const getDataAll = async () => {
    const response = await getData(
      `/admin/orders/product-order?page=${onPageChange || 1}&per_page=${
        perPage?.value || 25
      }&sortOrder=${sortOrder?.value || "DESC"}&from=${
        searchDateFrom || ""
      }&to=${searchDateTo || ""}&customer=${searchCustomer || ""}&customer_contact=${
        searchCustomerContact || ""
      }&product=${searchProduct || ""}&order_status_id=${selectedOrderStatus?.value || ""}&product_id=${appliedProduct?.value || ""}`,
    );

    setData(response);

    if (response?.data?.data?.length > 0) {
      response?.data?.data?.forEach((item) => {
        getOrderStatuses(item?.id);
      });
    }

    setCurrentPage(response?.data?.current_page);
    settotalPages(response?.data?.total_pages);
  };

  // Manual Search - Trigger only on Search button, Reset, Page Change, etc.
  useEffect(() => {
    getDataAll();
  }, [
    reset,
    searchOrderStatus,
    onPageChange,
    // selectedOrderStatus,
    appliedProduct,
  ]);

  const handlePageChange = (pageNumber) => {
    setonPageChange(pageNumber);
  };

  const paginationItems = [];
  for (let page = 1; page <= totalPages; page++) {
    paginationItems.push(
      <Pagination.Item
        key={page}
        active={page === onPageChange}
        onClick={() => handlePageChange(page)}
      >
        {page}
      </Pagination.Item>,
    );
  }

  const [showAssign, setShowAssign] = useState({ show: 0, data: {} });
  const [showReturnAssign, setShowReturnAssign] = useState({
    show: 0,
    data: {},
  });
  const [showDetails, setShowDetails] = useState({ show: 0, data: {} });

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      borderRadius: "20px",
      borderColor: "#ddd",
      boxShadow: "none",
      fontSize: "15px",
      "&:hover": {
        borderColor: "#aaa",
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: "#000",
    }),
    menu: (base) => ({
      ...base,
      borderRadius: "10px",
      boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
      color: "#000",
      fontSize: "15px",
      "&:hover": {
        backgroundColor: "#eee",
      },
    }),
  };

  // const ChangeOrderStatus = async (id, status_id, remark, selectedOption) => {
  //   try {
  //     await postData(`/admin/orders/product-order/update-status/${id}`, {
  //       order_status_id: status_id,
  //       remark,
  //     });

  //     // update selected dropdown value locally
  //     setSelectedStatus((prev) => ({
  //       ...prev,
  //       [id]: selectedOption,
  //     }));

  //     // clear remark field
  //     resetField(`remark_${id}`);

  //     // refresh data
  //     await getDataAll();
  //     await GetAllCounts();
  //   } catch (error) {
  //     console.error("Error updating order status:", error);
  //   }
  // };

  const ChangeOrderStatus = async (id, status_id, remark, selectedOption) => {
    try {
      const response = await postData(
        `/admin/orders/product-order/update-status/${id}`,
        {
          order_status_id: status_id,
          remark,
        },
      );

      if (response?.success) {
        setShowModal({
          code: response?.code,
          message: response?.message,
        });

        // update selected dropdown
        setSelectedStatus((prev) => ({
          ...prev,
          [id]: selectedOption,
        }));

        // refresh data
        await getDataAll();
        await GetAllCounts();
      } else {
        setShowModal({
          code: response?.code,
          message: response?.errors,
        });
      }

      // clear remark
      resetField(`remark_${id}`);

      // auto close popup after 1 second
      setTimeout(() => {
        setShowModal({
          code: 0,
          message: "",
        });
      }, 1000);
    } catch (error) {
      console.log(error);

      setShowModal({
        code: 500,
        message: "Something went wrong",
      });
    }
  };

  const downloadInvoice = async (invoiceUrl) => {
    try {
      const response = await fetch(invoiceUrl);
      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = "invoice.pdf"; // Set your preferred filename
      link.click();

      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  };

  const HandleDownload = async () => {
    if (data?.data?.data?.length <= 0) {
      alert("No record found");
    } else {
      try {
        await getDownloadDataExcel(
          `/admin/orders/download?page=${onPageChange || 1}&per_page=${
            perPage?.value || 25
          }&term=${search}&searchOrderStatus=${
            OrderStatusIds.Processing || ""
          }&storeCategory=${storeCategory}&productCategory=${
            productCategory.value || ""
          }&sortOrder=${sortOrder?.value || "DESC"}&from=${
            searchDateFrom || ""
          }&to=${searchDateTo || ""}&start_time=${
            searchStartTime || ""
          }&end_time=${searchEndTime || ""}&name=${search || ""}&customer=${
            searchCustomer || ""
          }`,
          null,
          "Order List",
        );
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const [product, setProduct] = useState([]);

  const GetAllProduct = async () => {
    const response = await getData("/common/masters/product");
    if (response?.success) {
      setProduct(await Select2Data(response?.data, "product_id"));
    }
  };

  useEffect(() => {
    GetAllProduct();
  }, []);

  return (
    <section className="pending-table_holder">
      <div className="quick-filters mt-3">
        <span className="quick-filters__label">
          <b>Quick Filters:</b>
        </span>
        <div className="quick-filters__tabs mt-3">
          <div className="row">
            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="from"
                  value={searchDateFrom}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Check if year has 4 digits
                    if (year.length === 4 || value === "") {
                      setSearchDateFrom(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">End Date</label>
                <input
                  type="date"
                  className="form-control"
                  placeholder="to"
                  value={searchDateTo}
                  onChange={(e) => {
                    const value = e.target.value;
                    const year = value.split("-")[0];

                    // Allow only if year is 4 digits or input is empty
                    if (year.length === 4 || value === "") {
                      setSearchDateTo(value);
                      setonPageChange(1);
                    }
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Order Status</label>

                <Select
                  isSearchable
                  options={allOrderStatuses}
                  value={selectedOrderStatus}
                  placeholder="Select Order Status"
                  onChange={(e) => {
                    setSelectedOrderStatus(e);
                    setonPageChange(1);
                  }}
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="num me-2">
                <label className="form-label">Select Product</label>

                <Select
                  isSearchable
                  options={allProducts}
                  value={selectedProduct}
                  placeholder="Select Product"
                  onChange={(e) => {
                    setSelectedProduct(e); // only UI state
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row align-items-end mb-3">
        <div className="col-12 mb-2">
          <div className="row">
            {/* <div className="col-lg-3 mb-2">
              <Form.Label>Select Product </Form.Label>
              <Select
                isSearchable
                options={product}
                value={productCategory}
                placeholder="Select Product"
                onChange={(e) => {
                  setProductCategory(e);
                }}
                classNamePrefix="searchProduct"
              />
            </div> */}
            {/* <div className="col-lg-3 mb-2">
              <Form.Label>Product Name</Form.Label>
              <Form.Control
                placeholder="Enter Product Name"
                type="text"
                className="form-control"
                value={searchProduct}
                onChange={(e) => {
                  setSearchProduct(e.target.value);
                }}
              />
            </div> */}
            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                placeholder="Enter Customer Name"
                type="text"
                className="form-control"
                id=""
                value={searchCustomer}
                onChange={(e) => {
                  setSearchCustomer(e.target.value);
                }}
              />
            </div>

            <div className="col-lg-3 mb-2">
              <Form.Label>Customer Contact No</Form.Label>
              <Form.Control
                placeholder="Enter Customer Contact No"
                type="text"
                className="form-control"
                id=""
                value={searchCustomerContact}
                onChange={(e) => {
                  setSearchCustomerContact(e.target.value);
                }}
              />
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-1 col-md-1">
              <div className="Search me-2">
                <Form.Label>Search</Form.Label>
                <Button
                  type="button"
                  onClick={() => {
                    setAppliedProduct(selectedProduct); // APPLY FILTER HERE
                    setonPageChange(1);
                    getDataAll();
                  }}
                  className="btn btn-search"
                >
                  <img src={search1} className="search" alt="" />
                </Button>
              </div>
            </div>
            <div className="col-xxl-1 col-xl-1  col-lg-2 col-md-2">
              <div className="Search-1">
                <Form.Label>Reset</Form.Label>
                {/* <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchCustomerContact("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");
                    setSearchCustomer("");
                    setProductCategory("");
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button> */}
                <button
                  type="button"
                  onClick={() => {
                    setSearch("");
                    setSearchCustomer("");
                    setSearchCustomerContact("");
                    setSearchProduct("");
                    setSearchDateFrom("");
                    setSearchDateTo("");
                    setSearchEndTime("");
                    setSearchStartTime("");

                    setSelectedOrderStatus(null);

                    setSelectedProduct(null);
                    setAppliedProduct(null);

                    setonPageChange(1);
                    setReset(!reset);
                  }}
                  className="btn btn-reset"
                >
                  Reset
                </button>
              </div>
            </div>

            {/* <div className=" col-xl-2 col-lg-4 col-md-6 col-12 mb-2">
              <Form.Label> Download Excel</Form.Label>
              <div>
                <button
                  className="btn btn-success mt-2"
                  type="button"
                  onClick={HandleDownload}
                >
                  Excel
                  <FontAwesomeIcon
                    icon="fa-solid fa-file-lines"
                    className="ms-2"
                  />
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>

      <div>
        <div>
          <strong>Total Order:</strong>
          {data?.data?.data?.length}
        </div>
        {/* <div>
          <strong>Total Amount:</strong> ₹
          {Number(data?.data?.total_selling_value || 0).toFixed(2)}
        </div>
        <div>
          <strong>Average Amount:</strong> ₹
          {Number(data?.data?.average_selling_value || 0).toFixed(2)}
        </div> */}
        {/* <div>
          <strong>Total Kg:</strong>{" "}
          {Number(data?.data?.total_weight || 0).toFixed(2)} kg
        </div> */}
      </div>

      {/* Table Section */}
      <div className="pending-table ">
        <Table striped bordered hover className="order-table" responsive>
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th>Order Date</th>
              <th>Order details</th>
              <th>Products</th>
              <th>Total</th>
              <th>Delivery Details</th>
              <th>Invoice</th>
              <th>Order Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.data?.map((item, index) => {
              const srNo =
                (onPageChange - 1) * (perPage?.value || 25) + index + 1;

              return (
                <tr key={index}>
                  {/* Sr. No. */}
                  <td>{srNo}.</td>

                  {/* Order Date */}
                  <td className="order-date">
                    <div className="order-id">
                      {formatDateToIST(item?.createdAt)}
                    </div>
                  </td>

                  {/* Owner Details */}
                  <td className="order-details">
                    <div className="order-id text-highlight">
                      {item?.invoice_no}
                    </div>
                    <div className="order-info">
                      <span>
                        <b>Buyer Name</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span className="text-highlight">{item?.User?.name}</span>
                    </div>
                    <div className="order-info">
                      <span>{item?.User?.contact_no}</span>
                    </div>
                    <div className="order-info">
                      <span>{item?.User?.email}</span>
                    </div>

                    <div className="order-info">
                      <span>{item?.Payment_Method?.name}</span>
                    </div>
                  </td>
                  {/* Products Column */}
                  <td className="order-details">
                    {item?.Product_Order_Details &&
                    item.Product_Order_Details.length > 0 ? (
                      item.Product_Order_Details.map((product, idx) => (
                        <React.Fragment key={product.id || idx}>
                          <div className="text-highlight">
                            <span>
                              <b>{idx + 1}. Product Name</b>
                            </span>
                            :<span>{product?.Product?.name || "-"}</span>
                          </div>
                          <div className="order-info">
                            <span>
                              <b>Category Name</b>
                            </span>
                            :
                            <span>
                              {product?.Product?.p_category?.name || "-"}{" "}
                            </span>
                          </div>
                          <div className="order-info">
                            <span>
                              <b>Sub Category Name</b>
                            </span>
                            :
                            <span>
                              {product?.Product?.p_sub_category?.name ||
                                "-"}{" "}
                            </span>
                          </div>
                          <div className="order-info">
                            <span>
                              <b>Child Category Name</b>
                            </span>
                            :
                            <span>
                              {product?.Product?.p_child_category?.name ||
                                "-"}{" "}
                            </span>
                          </div>
                          {idx < item.Product_Order_Details.length - 1 && (
                            <hr className="my-2" />
                          )}
                        </React.Fragment>
                      ))
                    ) : (
                      <span>-</span>
                    )}

                    {isAllow?.includes(IDS.Order.View) ? (
                    <div className="mt-3">
                      <Button
                        className="action-btn active"
                        onClick={() =>
                          setShowDetails({
                            show: item?.id,
                            data: item?.Product_Order_Details,
                          })
                        }
                      >
                        View All Details
                      </Button>
                    </div>
                    ) : (
                      <></>
                    )}
                  </td>

                  <td className="order-details">
                    <div className="order-id">
                      <span>
                        <b>Total SubTotal</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {item.Exchange_Rate?.symbol || "$"}{" "}
                        {Number(item?.sub_total_amount).toFixed(2)} /-
                      </span>
                    </div>

                    <div className="order-id">
                      <span>
                        <b>Shipping Charges</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "$"}{" "}
                        {Number(item?.shipping_charge).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Offer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.total_offer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Coupon Discount</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "$"}{" "}
                        {Number(item?.total_coupon_discount).toFixed(2)} /-
                      </span>
                    </div>
                    {/* <div className="order-id">
                    <span>Refer Discount</span>
                  </div>
                  <div className="order-info">
                    <span>{item?.refer_discount} /-</span>
                  </div> */}
                    <div className="order-id">
                      <span>
                        <b>Total Tax</b>
                      </span>
                    </div>
                    <div className="order-info">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "$"}{" "}
                        {Number(item?.total_tax).toFixed(2)} /-
                      </span>
                    </div>
                    <div className="order-id">
                      <span>
                        <b>Grand Total</b>
                      </span>
                    </div>
                    <div className="text-highlight">
                      <span>
                        {" "}
                        {item.Exchange_Rate?.symbol || "$"}{" "}
                        {Number(item?.total_amount).toFixed(2)} /-
                      </span>
                    </div>
                  </td>

                  <td>
                    <>
                      <div className="text-highlight">
                        <span>{item?.User_Address?.first_name} </span>
                      </div>
                      <div className="order-info">
                        <span>
                          {item?.User_Address?.Users_Address_Detail?.address} ,
                        </span>
                      </div>
                      <div className="order-info">
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Country
                              ?.name
                          }{" "}
                          ,
                        </span>
                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.State
                              ?.name
                          }
                          ,{" "}
                        </span>
                        <span>
                          {item?.User_Address?.Users_Address_Detail?.City?.name}{" "}
                          ,
                        </span>

                        <span>
                          {
                            item?.User_Address?.Users_Address_Detail?.Pincode
                              ?.name
                          }
                          ,{" "}
                        </span>
                      </div>
                      <div className="text-highlight">
                        <span>{item?.User_Address?.contact_no} </span>
                      </div>
                    </>
                  </td>

                  <td>
                    {item?.invoice ? (
                      <Button
                        variant="success"
                        size="sm"
                        onClick={() => downloadInvoice(IMG_URL + item.invoice)}
                      >
                        Download Invoice
                      </Button>
                    ) : (
                      <span className="text-danger">Invoice Not Available</span>
                    )}
                  </td>

                  <td>
                    {item?.order_status_id === 4 ? (
                      <div>
                        <p className="status-holder shipped">
                          {item?.Order_status?.name}
                        </p>
                      </div>
                    ) : (
                      <div>
                        <p className="status-holder Unshipped">
                          <b>{item?.Order_status?.name}</b>
                        </p>
                      </div>
                    )}
                  </td>

                  <td>
                    {/* <div className="my-1">
                    <Button
                      className="action-btn active"
                      onClick={() =>
                        ChangeOrderStatus(item?.id, OrderStatusIds.Preparing)
                      }
                    >
                      {" "}
                      Send Preparing Order{" "}
                    </Button>
                  </div> */}
                    {isAllow?.includes(IDS.Order.Status) ? (
                    <div className="my-1" style={{ minWidth: "220px" }}>
                      <Form.Label>Change Order Status</Form.Label>

                      <Select
                        styles={{
                          control: (baseStyles) => ({
                            ...baseStyles,
                            minHeight: "38px",
                          }),
                        }}
                        placeholder="Select Status"
                        options={orderStatuses[item?.id] || []}
                        // value={
                        //   selectedStatus[item?.id] ||
                        //   (orderStatuses[item?.id] || [])?.find(
                        //     (status) => status.value === item?.order_status_id,
                        //   ) ||
                        //   null
                        // }
                        value={selectedStatus[item?.id] || null}
                        onChange={(selectedOption) => {
                          setSelectedStatus((prev) => ({
                            ...prev,
                            [item?.id]: selectedOption,
                          }));

                          setStatusErrors((prev) => ({
                            ...prev,
                            [item?.id]: "",
                          }));
                        }}
                      />

                      {statusErrors[item?.id] && (
                        <p className="text-danger mt-1 mb-0">
                          {statusErrors[item?.id]}
                        </p>
                      )}

                      <Form.Control
                        type="text"
                        placeholder="Enter Remark"
                        className="mt-2"
                        {...register(`remark_${item?.id}`, {
                          required: "Remark is required",
                        })}
                      />

                      {errors[`remark_${item?.id}`] && (
                        <p className="text-danger mt-1 mb-0">
                          {errors[`remark_${item?.id}`]?.message}
                        </p>
                      )}
                      <Button
                        className="action-btn active mt-2"
                        onClick={async () => {
                          const fieldName = `remark_${item?.id}`;

                          const selectedOption = selectedStatus[item?.id];

                          const remark = watch(fieldName);

                          let hasError = false;

                          // validate status
                          if (!selectedOption) {
                            setStatusErrors((prev) => ({
                              ...prev,
                              [item?.id]: "Order status is required",
                            }));

                            hasError = true;
                          } else {
                            setStatusErrors((prev) => ({
                              ...prev,
                              [item?.id]: "",
                            }));
                          }

                          // validate remark
                          const isValid = await trigger(fieldName);

                          if (!isValid) {
                            hasError = true;
                          }

                          if (hasError) return;

                          await ChangeOrderStatus(
                            item?.id,
                            selectedOption?.value,
                            remark,
                            selectedOption,
                          );

                          // reset status dropdown
                          setSelectedStatus((prev) => ({
                            ...prev,
                            [item?.id]: null,
                          }));

                          // reset remark
                          resetField(fieldName);
                        }}
                      >
                        OK
                      </Button>
                    </div>
                    ) : (
                      <></>
                    )}

                    {/* <div className="my-1">
                    <Button
                      className="action-btn"
                      onClick={() => downloadInvoice(IMG_URL + item?.invoice)}
                    >
                      Print Invoice
                    </Button>
                  </div> */}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {data && data?.data?.data?.length > 0 ? (
          <Pagination_Holder
            onPageChange={currentPage}
            totalPages={totalPages}
            handlePageChange={handlePageChange}
          />
        ) : (
          <p className="no-datashow">Sorry, No Data Found</p>
        )}
      </div>

      <ProductModal
        handleClose={() => {
          setShowDetails({ show: 0, data: {} });
        }}
        setShow={() => setShowDetails({ show: 0, data: {} })}
        show={showDetails?.show}
        data={showDetails?.data}
      />

      <ProductVariantModal />
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </section>
  );
}

export default PendingOrdersTable;
